( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .factory( 'ShipmentReport', ShipmentReport );

    ShipmentReport.$inject = [ '$resource', 'DateUtils' ];

    function ShipmentReport( $resource, DateUtils ) {
        var resourceUrl = "api/shipments/report/:id";

        return $resource( resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
